module.exports = __webpack_public_path__ + "img/客服帮助.306fbdb9.png";